import {all, takeEvery, put, call, select} from 'redux-saga/effects';
import { getWorkspaceUsersApi } from "../../services/workspace.service";
import actions from "./actions";
import {ReducerType} from "../reducer.type";
import { AxiosResponse } from 'axios';
import { WorkspaceType } from '../user/user.type';

const getWorkspace = (state: ReducerType) => state.user.activeWorkspace;

export function* GET_ALL_USERS() {
    const workspace: WorkspaceType = yield select(getWorkspace);
    if (workspace){
        try {
            const response: AxiosResponse<any> = yield call(getWorkspaceUsersApi, workspace.uuid);
            if (response.data) {
                yield put({
                    type: actions.SET_DATA,
                    payload: response.data
                })
            }
        } catch (e) {

        }
    }
}
export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_ALL_USERS)
    ])
}
